<script>
import $store from '@/store'
// const _import = require('@/store/modules/common/import.js').loadPng
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render(h, context) {
    const { icon, title } = context.props
    const vnodes = []

    if (icon) {
      if (icon.indexOf('.png') === -1) {
        vnodes.push(<svg-icon icon-class={icon}/>)
      } else {
        const vnode = h(
          'img',
          {
            attrs: {
              src: '/static/menu/' + icon
            },
            style: {
              width: '25px',
              'user-select': 'none',
              height: '25px',
              'margin-right': '15px',
              'margin-left': '5px',
              display: 'inline-block'
            }
          }
        )
        vnodes.push(vnode)
      }
    }

    if (title) {
      if ($store.getters.language === 'zh') {
        vnodes.push(<span slot='title' title={(title)} style='display:inline-block;width:100px;overflow:hidden;white-space:nowrap;text-overflow: ellipsis;'>{(title)}</span>)
      } else {
        vnodes.push(<span slot='title' title={(title)} style='display:inline-block;width:180px;overflow:hidden;white-space:nowrap;text-overflow: ellipsis;'>{(title)}</span>)
      }
    }
    return vnodes
  }
}
</script>
